module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/murin4-bd37f66b3dff4f13deb3a1c901a7bf96.jpg";